import React, { Fragment, useContext, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import NavBar from '../../layouts/global/NavBar';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { Redirect, useHistory } from 'react-router';
import axios from 'axios';
import LoadingSpinner from '../../components/LoadingSpinner';
import SampleImage from '../../assets/images/sampleImg.png';

const countries = [
  { country: 'Ghana', currency: 'GHS' },
  { country: 'Uganda', currency: 'UGX' },
  { country: 'Nigeria', currency: 'NGN' },
  { country: 'Zambia', currency: 'ZMK' },
  { country: 'Rwanda', currency: 'RWF' },
  { country: 'Tanzania', currency: 'TZS' },
  { country: 'Kenya', currency: 'KES' },
];

export default function RegisterPage() {
  const { state } = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState(null);
  const history = useHistory();
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    currency: Yup.string().required('Country is required'),
    email: Yup.string()
      .email('Enter a valid email')
      .required('Email is required'),
    password: Yup.string().required('Password is required'),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref('password'), null],
      'Passwords must match',
    ),
  });

  const createUserAccount = async (values, actions) => {
    actions.setSubmitting(true);
    try {
      const response = await axios.post(
        'https://secret-ridge-31139.herokuapp.com/api/auth/register',
        {
          name: values.name,
          currency_code: values.currency,
          email: values.email,
          password: values.password,
          password_confirmation: values.confirmPassword,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (response) {
        actions.setSubmitting(false);
        history.push('/login');
      }
    } catch (error) {
      setErrorMessage(error.response.data);
      return error.response.data;
    }
  };

  return (
    <Fragment>
      {state.isAuth ? <Redirect to="/dashboard" /> : null}
      <main>
        <NavBar />
        <div
          className={
            'min-h-screen flex flex-col lg:flex-row pt-20 px-10 lg:px-24'
          }
        >
          <div className={'w-full lg:w-1/2'}>
            <div className={'w-full lg:w-2/3 mt-14'}>
              <div className={'mb-5'}>
                <h3 className={'text-2xl font-semibold text-gray-500'}>
                  Register to enjoy our platform
                </h3>
              </div>
              {errorMessage ? (
                <div className={'p-3  bg-red-50 text-red-600'}>
                  <p>{errorMessage}</p>
                </div>
              ) : null}
              <Formik
                initialValues={{
                  name: '',
                  email: '',
                  currency: '',
                  password: '',
                  confirmPassword: '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, formikHelpers) =>
                  createUserAccount(values, formikHelpers)
                }
              >
                {(props) => (
                  <form>
                    <div className={'py-2'}>
                      <input
                        className={
                          'shadow-md w-full border-2 border-gray-400 bg-gray-50 rounded p-3'
                        }
                        name={'name'}
                        type={'text'}
                        placeholder={'Name *'}
                        value={props.values.name}
                        onChange={props.handleChange('name')}
                        onBlur={props.handleBlur('name')}
                      />
                      <p className={'text-red-500 text-sm'}>
                        {props.touched.name && props.errors.name}
                      </p>
                    </div>
                    <div className={'py-2'}>
                      <select
                        className={
                          'shadow-md w-full border-2 border-gray-400 bg-gray-50 rounded p-3'
                        }
                        name={'currency'}
                        value={props.values.currency}
                        onChange={props.handleChange('currency')}
                      >
                        <option>Select country</option>
                        {countries.map((item, index) => (
                          <option key={index} value={item.currency}>
                            {item.country}
                          </option>
                        ))}
                      </select>
                      <p className={'text-red-500 text-sm'}>
                        {props.touched.currency && props.errors.currency}
                      </p>
                    </div>
                    <div className={'py-2'}>
                      <input
                        className={
                          'shadow-md w-full border-2 border-gray-400 bg-gray-50 rounded p-3'
                        }
                        name={'email'}
                        type={'email'}
                        placeholder={'Email Address *'}
                        value={props.values.email}
                        onChange={props.handleChange('email')}
                        onBlur={props.handleBlur('email')}
                      />
                      <p className={'text-red-500 text-sm'}>
                        {props.touched.email && props.errors.email}
                      </p>
                    </div>
                    <div className={'py-2'}>
                      <input
                        className={
                          'shadow-md w-full border-2 border-gray-400 bg-gray-50 rounded p-3'
                        }
                        name={'password'}
                        type={'password'}
                        placeholder={'Password *'}
                        value={props.values.password}
                        onChange={props.handleChange('password')}
                        onBlur={props.handleBlur('password')}
                      />
                      <p className={'text-red-500 text-sm'}>
                        {props.touched.password && props.errors.password}
                      </p>
                    </div>
                    <div className={'py-2'}>
                      <input
                        className={
                          'shadow-md w-full border-2 border-gray-400 bg-gray-50 rounded p-3'
                        }
                        name={'confirmPassword'}
                        type={'password'}
                        placeholder={'Confirm Password *'}
                        value={props.values.confirmPassword}
                        onChange={props.handleChange('confirmPassword')}
                        onBlur={props.handleBlur('confirmPassword')}
                      />
                      <p className={'text-red-500 text-sm'}>
                        {props.touched.confirmPassword &&
                          props.errors.confirmPassword}
                      </p>
                    </div>
                    <div
                      className={
                        'mt-5 flex flex-col lg:flex-row justify-between items-center'
                      }
                    >
                      <button
                        type={'button'}
                        onClick={() => props.handleSubmit()}
                        className={
                          'bg-yellow-500 text-white border-2  border-yellow-500  rounded px-5 py-3 w-full lg:w-auto mb-2 lg:mb-0'
                        }
                      >
                        {props.isSubmitting ? (
                          <LoadingSpinner color={'text-white'} />
                        ) : (
                          'Register'
                        )}
                      </button>
                      <Link to={'/login'}>
                        <span className={'underline text-yellow-500 text-lg'}>
                          Log in here
                        </span>
                      </Link>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
          <div
            className={
              'w-full mt-2 lg:mt-0 lg:w-1/2 flex justify-center items-center'
            }
          >
            <img src={SampleImage} alt={''} className={'w-full'} />
          </div>
        </div>
      </main>
    </Fragment>
  );
}
